import wx from 'common/scripts/wx.js';
import WxGameJsCoreBridge from 'common/jscore/index.js';
import {getValue} from 'base/mbase.js';

function prerenderHandle(el) {
    if(getValue(el, '_binding.value.url')) {
        // WXGAME.WxGameJsCoreBridge.preRender({
        WxGameJsCoreBridge.preRender({
            htmlUrl: getValue(el, '_binding.value.url')
        })
        .then((res) => {
            getValue(el, '_binding.value.callback') && el._binding.value.callback({type: 2, data: res});
        })
        .catch((res) => {
            getValue(el, '_binding.value.callback') && el._binding.value.callback({type: 3, data: res});
        });
        getValue(el, '_binding.value.callback') && el._binding.value.callback({type: 1});
    }
}

export default {
    install(Vue) {
        // 注册一个全局自定义指令 v-prerender=“{url: "xxxx", callback: xx}” 
        // callback为可选参数,会在不同时机进行回调
        // v-prerender.bindclick="{url: "xx",clickCbk: cbk}" bindclick为开始点击跳转，可以通过clickCbk为点击回调
        Vue.directive('prerender', {
            bind(el, binding, vnode) {
                // console.log('openurl', this, binding);
                el._binding = binding;

                // 绑定曝光事件
                el._ob = wx.createIntersectionObserver(document, { observeAll: true, thresholds: [0] });
                el._ob.relativeToViewport({ bottom: 0 }).observe(el, ( {intersectionRatio}) => {
                    if(intersectionRatio > 0 && !el._ob.hadExposured) {
                        el._ob.hadExposured = true;
                        // 曝光
                        logInfo(`预渲染入口曝光 ${window.__jscore_state__} ${!!window.WxGameJsCoreNative} ${el._binding.value.url}`);
                        prerenderHandle(el);
                    }
                });

                // 绑定点击事件
                if(el._binding.modifiers.bindclick) {
                    el.addEventListener('click', (e) => {
                        if(getValue(el, '_binding.value.url')) {
                            // 跳转
                            WXGAME.WxBridge.openUrl(el._binding.value.url, {
                                useJscore: true,
                            }, (res) => {
                                getValue(el, '_binding.value.callback') && el._binding.value.callback({type: 5, data: res});
                            });
                            getValue(el, '_binding.value.callback') && el._binding.value.callback({type: 4});
                        }
                        getValue(el, '_binding.value.clickCbk') && el._binding.value.clickCbk({url: el._binding.value.url});
    
                        if(el._binding.modifiers.stop) {
                            e.stopPropagation();
                        } 
                    });
                }
            },
            update(el, binding, vnode) {
                el._binding = binding;
                // 如果更新时已经曝光过，则需要重新出发预渲染
                if(el._ob && el._ob.hadExposured && getValue(binding, 'oldValue.url') !== getValue(binding, 'value.url')) {
                    logInfo(`预渲染入口更新 from:${binding.oldValue.url} to:${binding.value.url}`);
                    prerenderHandle(el);
                }
            },
            unbind(el) {
                el._binding = undefined;
                el._ob.disconnect();
                el._ob = undefined;
            }
        })
    }
}